import { useDisclosure } from "@chakra-ui/react";
import { useStores } from "../../../../stores/setup/use-store";

interface UseLocationTypeConfirmationProps {
	isEditing: boolean;
	values: any;
	locationType: string | null;
	onConfirm: (values: any, isEditing: boolean) => void;
}

export const useLocationTypeConfirmation = ({
	isEditing,
	values,
	locationType,
	onConfirm,
}: UseLocationTypeConfirmationProps) => {
	const {
		dataStores: { operationRuleLocationStore },
	} = useStores();

	const {
		isOpen: isModalOpen,
		onOpen: onModalOpen,
		onClose: onModalClose,
	} = useDisclosure();

	const shouldShowConfirmationModal = (): boolean => {
		if (!isEditing) return false;

		const opLocation = operationRuleLocationStore.operationRuleLocation as any;

		const originalIsPoint = !!(opLocation?.regionId && opLocation?.stationId);
		const currentLocationType = values.locationType || locationType;

		return originalIsPoint && currentLocationType === "area";
	};

	const handleSaveClick = (): void => {
		if (shouldShowConfirmationModal()) {
			onModalOpen();
		} else {
			onConfirm(values, isEditing);
		}
	};

	const handleConfirmChange = (): void => {
		onModalClose();
		onConfirm(values, isEditing);
	};

	return {
		isModalOpen,
		onModalClose,
		handleSaveClick,
		handleConfirmChange,
	};
};